import UserInvitationDeclineModal from './UserInvitationDeclineModal';

export default UserInvitationDeclineModal;
